<template>
  <div>
    <!-- Profiles -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature3"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        {{ $t('title') }}
      </h3>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
          style="min-height:660px;height:55vh;"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              {{ $t('card1.title') }}
            </h6>
            <div class="row">
              <div
                class="position-relative"
                style="margin-bottom: -19px; width: calc(100% - 340px);"
              >
                <figure class="image-feature3-item1" role="img-left"></figure>
                <picture class="img-left">
                  <source
                    srcset="/img/profile/profile-dark.png"
                    media="(prefers-color-scheme: dark)"
                    loading="lazy"
                  />
                  <source
                    srcset="/img/profile/profile-light.png"
                    media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                    loading="lazy"
                  />
                  <img
                    data-aos="fade-right"
                    data-aos-duration="2000"
                    data-aos-delay="400"
                    src="/img/profile/profile-light.png"
                    id="screenshot"
                    loading="lazy"
                    width="85%"
                  />
                </picture>
              </div>
              <p
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="2000"
                class="mdc-typography--headline3 image-feature3-item1-text text-color font-weight-bold d-flex position-relative align-items-center"
                style="height: 703px;width: 340px;top: -10px;left:-80px;line-height: 1.1;"
              >
                {{ $t('card1.subtitle') }}
              </p>
            </div>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->

        <div
          class=" mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
        >
          <h6
            class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center"
          >
            {{ $t('card1.tab1') }}
          </h6>
        </div>
        <div
          class="mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone"
        >
          <h6
            class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center"
          >
            {{ $t('card1.tab2') }}
          </h6>
        </div>
        <div
          class="mdc-layout-grid__cell title-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-1-phone"
        >
          <h6
            class="mdc-typography--headline6 text-nav text-color text-center h-100 d-flex align-items-center justify-content-center"
          >
            {{ $t('card1.tab3') }}
          </h6>
        </div>
        <!-- .slider-navigation -->

        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color z-3">
              For you and your friends
            </h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto z-3"
            >
              Understand your users and how they interact with your channel and
              your videos.
            </p>
            <figure
              class="image-feature3-item1 z-1"
              role="img-full-bottom"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square p-5 d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color z-3">
              Startup Page
            </h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto z-3"
            >
              Create a startup page
            </p>
            <figure
              class="image-feature3-item2 z-1"
              role="img-full-bottom"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square p-5 d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color z-3">Salvați</h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto z-3"
            >
              Salvați rapid și sigur fotografii și videoclipuri în biblioteca
              dvs.
            </p>
            <figure
              class="image-feature3-item3"
              role="img-full-bottom"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
      </div>

      <div
        id="carouselExampleIndicators"
        class="carousel slide mt-4"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              class="d-block w-100 h-auto"
              src="../../public/img/darkmode/profile-dark.jpg"
              alt="First slide"
              loading="lazy"
            />
          </div>
          <div class="carousel-item">
            <img
              class="d-block w-100 h-auto"
              src="../../public/img/darkmode/profile-dark.jpg"
              alt="Second slide"
              loading="lazy"
            />
          </div>
          <div class="carousel-item">
            <img
              class="d-block w-100 h-auto"
              src="../../public/img/darkmode/profile-dark.jpg"
              alt="Third slide"
              loading="lazy"
            />
          </div>
        </div>

        <ol class="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
          >
            Test
          </li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profiles'
}
</script>

<i18n>
{
  "en": {
    "title": "Profile",
    "card1": {
      "title": "Represent your profile",
      "subtitle": "Keep all your friends up to date with the latest activities.",
      "tab1": "People",
      "tab2": "Business",
      "tab3": "Institutions"
    },
    "card2": {
      "title": "Build your resume",
      "subtitle": ""
    },
    "card3": {
      "title": "",
      "subtitle": ""
    },
    "card4": {
      "title": "",
      "subtitle": ""
    }
  },
  "ro": {
    "title": "Profile",
    "card1": {
      "title": "Reprezintă-ți profilul",
      "subtitle": "Mențineți-vă toți prietenii la curent cu cele mai recente activități.",
      "tab1": "Persoane",
      "tab2": "Afaceri",
      "tab3": "Instituții"
    }
  },
  "de": {
    "title": "Dein Profil",
    "card1": {
      "title": "Stellen Sie Ihr Profil dar",
      "subtitle": "Halten Sie alle Ihre Freunde über die neuesten Aktivitäten auf dem Laufenden.",
      "tab1": "Persönlich",
      "tab2": "Geschäft",
      "tab3": "Institution"
    }
  }
}
</i18n>

<style>
.img-left {
  display: flex;
  justify-content: flex-start;
}
@media (max-width: 575.98px) {
  .img-left {
    display: flex;
    justify-content: center;
  }
}
.carousel-inner {
  height: 739px;
}
.carousel-indicators {
  position: relative;
  margin: 0 !important;
}
.carousel-indicators li:nth-child(1) {
  margin-left: 0;
}
.carousel-indicators li:nth-child(3) {
  margin-right: 0;
}
.carousel-indicators li {
  width: 100%;
  height: 100px;
  margin-right: 5px;
  margin-left: 5px;
  background-color: #212121;
  flex: unset;
}
.image-feature3-item1 {
  background-image: url(/img/profile/personal.jpg);
  z-index: 1;
}
.image-feature3-item2 {
  background-image: url(/img/profile/startup.jpg);
  z-index: 1;
}
.image-feature3-item3 {
  background-image: url(/img/profile/business.jpg);
  z-index: 1;
}

figure[role='img-full-bottom'] {
  position: absolute;
  background-size: cover;
  background-position: bottom;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
figure[role='img-full-center'] {
  position: absolute;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
</style>
